export default __webpack_public_path__ + "static/background-physics-b488d91fbd4b03ceb94d2ba72bc96e61.jpg";